import { createApp } from 'vue'
import FloatingVue from 'floating-vue'
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import 'floating-vue/dist/style.css'

import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import FieldLabel from './components/inputs/FieldLabel.vue'
import './styles/index.css'
import './styles/mobile-responsive.css'

const app = createApp(App)

// Componente compartilhado de label (com link auxiliar opcional) usado pelos i-*.vue
app.component('FieldLabel', FieldLabel)

// Configurar plugins
app.use(router)
app.use(store)
app.use(i18n)
app.use(FloatingVue)
app.use(VueLoading, {
  color: '#556ee6',
  loader: 'dots',
  canCancel: false,
  isFullPage: false
})

// Variável global
window.__app_version = '1.0.0-JIMLN5K4'

app.mount('#app')
